export const handleClick = async () => {
    const url = document.getElementById("site_Url");
    if (url) {
        const siteUrl = url.textContent as string;

        try {
            // HTTPS 환경에서 클립보드에 복사
            await navigator.clipboard.writeText(siteUrl);
            alert("URL이 클립보드에 복사되었습니다.");
        } catch (error) {
            // HTTPS가 아닌 경우나 clipboard API가 지원되지 않는 경우
            const textArea = document.createElement("textarea");
            textArea.value = siteUrl;
            document.body.appendChild(textArea);
            textArea.select();

            try {
                // fallback method
                document.execCommand("copy");
                alert("URL이 클립보드에 복사되었습니다.");
            } catch (err) {
                console.error("복사에 실패했습니다:", err);
            }

            document.body.removeChild(textArea);
        }
    }
};
